import React, { useState } from "react";
import ChatBubble from "./ChatBubble";
import ChatPanel from "./ChatPanel";
const SupportChat = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleChat = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <ChatBubble isOpen={isOpen} onClick={toggleChat} hasUnread={false} />
      <ChatPanel isOpen={isOpen} onClose={() => setIsOpen(false)} {...props}/>
    </>
  );
};
export default SupportChat;
